import {atom} from "recoil";

/**
 * PollPage로 갈 때 이전 페이지가 AppointmentCreatePage인지 여부
 * 프로그레스 바 단계를 동적으로 표시하기 위해 사용
 */
export const fromCreatePageState = atom<boolean>({
    key: 'fromCreatePageState',
    default: false,
})